import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useOutletContext } from "react-router-dom";
import { Award, Music2, Sparkles } from "lucide-react";

export default function About() {
  const { settings } = useOutletContext();
  return (
    <div className="container-x section">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="eyebrow mb-3">About Songniture</div>
          <h1 className="font-heading text-4xl md:text-5xl mb-6">A Song Inspired By Your Company&apos;s Vision.</h1>
          <p className="text-white/70 leading-relaxed mb-4">
            Songniture is a luxury music branding studio that transforms businesses into unforgettable musical experiences.
            We create custom theme songs, jingles, and brand soundtracks that build emotional connections between brands
            and their audiences.
          </p>
          <p className="text-white/70 leading-relaxed mb-8">
            Founded by Perry Frazier, a seasoned producer with a passion for storytelling through sound, Songniture pairs
            studio-grade production with deep brand strategy — so every song doesn&apos;t just sound good, it stays with you.
          </p>
          <div className="grid grid-cols-3 gap-6">
            <Stat icon={Music2} value="200+" label="Songs Produced" />
            <Stat icon={Award} value="50+" label="Industries" />
            <Stat icon={Sparkles} value="100%" label="Custom" />
          </div>
        </div>
        <div className="relative">
          <div className="absolute -inset-3 bg-gradient-to-br from-gold/20 via-transparent to-gold-dark/30 blur-2xl" />
          <img src={settings?.founder_photo || "/perry-frazier.jpeg"} alt="Perry Frazier" className="relative w-full border border-gold/40" />
          <div className="mt-6">
            <div className="font-heading text-2xl text-gold">{settings?.founder_name}</div>
            <div className="text-[11px] tracking-[0.25em] uppercase text-white/60 font-semibold">{settings?.founder_title}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Stat({ icon: Icon, value, label }) {
  return (
    <div className="border border-ink-700 p-5 bg-ink-900 hover:border-gold transition-colors">
      <Icon className="text-gold mb-3" size={24} />
      <div className="font-heading text-3xl text-white">{value}</div>
      <div className="text-[11px] tracking-[0.2em] uppercase text-white/60 font-semibold">{label}</div>
    </div>
  );
}
